import axios from 'axios';
import { Message, MessageBox } from 'element-ui';
import store from '../store';
import { getToken } from '@/utils/storage';
import ENVIRONMENT from '@/utils/environment';
import qs from 'qs';
import { apiLoadingShow, apiLoadingHide } from '@/utils/loading';
// 创建axios实例
const service = axios.create({
  baseURL: ENVIRONMENT.BASE_API, // api 的 base_url
  timeout: 1000 * 60 // 请求超时时间
});

// request拦截器
service.interceptors.request.use(
  config => {
    // config.baseURL = '/api';
    // 设置浏览器不缓存
    apiLoadingShow();
    config.headers['Cache-Control'] = 'no-cache';
    config.headers['Pragma'] = 'no-cache';
    // 设置请求数据格式
    config.headers['Content-Type'] = config.headers['Content-Type'] || 'application/json;charset=UTF-8';
    if (getToken()) {
      const Token = getToken();
      config.headers['Authorization'] = `Bearer ${Token}`;
    }
    if (config.method === 'post') {
      // 如果为post请求，要求Content-Type为json时，数据需要转换成JSON字符串
      if (config.headers['Content-Type'] === 'application/json;charset=UTF-8') {
        config.data = JSON.stringify(config.data);
      } else {
        // 如果是FormData参数据不需要qs序列化处理，否则默认Content-Type数据格式都需要qs序列化处理
        if (!(config.data instanceof FormData)) {
          config.data = qs.stringify(config.data);
        }
      }
    }
    return config;
  },
  error => {
    // Do something with request error
    console.log(error); // for debug
    Promise.reject(error);
  }
);

// response 拦截器
service.interceptors.response.use(
  response => {
    const res = response.data;
    apiLoadingHide();
    if (res.code !== '0') {
      if (res.code === '401' || res.code === '5138') {
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        });
        MessageBox.alert('登录已失效，请重新登录！', '提示', {
          confirmButtonText: '确定',
          type: 'warning',
          showClose: false
        }).then(() => {
          store.dispatch('FedLogOut').then(() => {
            // this.$router.push('/');
            // location.reload(); // 为了重新实例化vue-router对象 避免bug
          });
        });
      } else {
        if (response.config.params && response.config.params.export && res && !res.failed) {
          // 如果是导出，response.data返回为乱码则不判断
          return response.data;
        }
        // 如果需要自定义对错误做处理
        if (response.config.data && response.config.data.indexOf('custom') > -1) {
          return response.data;
        }
        // 统一处理错误信息
        Message({
          message: res.message,
          type: 'error',
          duration: 3 * 1000
        });
      }
      return Promise.reject(response);
    } else {
      return response.data;
    }
  },
  error => {
    apiLoadingHide();
    console.log('err' + error); // for debug
    if (error.message.includes('timeout')) { // 判断请求异常信息中是否含有超时timeout字符串
      Message({
        message: '请求超时',
        type: 'error'
      });
    } else if (error.response) {
      switch (error.response.status) {
        case 200:

          break;
        case 401:
          break;
        case 403:
        case 404:
        case 500:

          break;
        default:

          break;
      }
    }
    return Promise.reject(error.response);
  }
);

export default service;
